import React from "react";
import { ErrorBoundary } from "react-error-boundary";
import SpinnerWithLoadMask from "components/SpinnerWithLoadMask";
import FolderEmptySummaryContent from "layout/folderEmptySummary/FolderEmptySummaryContent";
import ErrorFallbackModal from "components/Modal/ErrorFallbackModal";

const FolderEmptySummary = () => {
  return (
    <ErrorBoundary FallbackComponent={ErrorFallbackModal}>
      <SpinnerWithLoadMask opacity={0.7} fullScreen />
      <FolderEmptySummaryContent />
    </ErrorBoundary>
  );
};

export default FolderEmptySummary;
